;(function (angular, _) {
  'use strict'

  angular
    .module('kilo.common.services')
    .service('SelectionService', SelectionService)

  SelectionService.$inject = []

  /**
   * Constructor
   */
  function SelectionService () {
    function Selection (compare) {
      var self = this

      compare = compare || '_id'
      if (compare) {
        if (typeof compare === 'function') self.compareFunc = compare
        else if (typeof compare === 'string') {
          self.compareFunc = function (elt) { return _.get(elt, compare) }
        }
      }

      self.compare = function (a, b) { return self.compareFunc(a) === self.compareFunc(b) }

      _.extend(self, {
        // Public Attributes
        selectedData: [],

        // Public Methods
        select: select,
        selectAll: selectAll,
        areAllSelected: areAllSelected,
        isEmpty: isEmpty,
        isSelected: isSelected,
        reset: reset

      })

      Object.defineProperty(self, 'length', {
        get: function () {
          if (!this.selectedData) return 0
          return this.selectedData.length
        }
      })

      function select (el) {
        self.selectedData = self.selectedData || []
        if (!isSelected(el)) {
          self.selectedData.push(el)
        } else {
          _.remove(self.selectedData, function (selected) {
            return self.compare(selected, el)
          })
        }
      }

      function selectAll (list) {
        if (!areAllSelected(list)) {
          self.selectedData = _.clone(list)
        } else {
          self.selectedData = []
        }
      }

      function areAllSelected (list) {
        if (!list || !list.length) return false
        return !_.differenceBy(list, self.selectedData, self.compareFunc).length
      }

      function isEmpty () {
        return self.selectedData.length === 0
      }

      function isSelected (el) {
        return _.some(self.selectedData, function (sel) {
          return self.compareFunc(el) === self.compareFunc(sel)
        })
      }

      function reset() {
        self.selectedData = []
      }
    }

    this.getSelection = function (compareFunc) {
      return new Selection(compareFunc)
    }
  }
})(window.angular, window._)
